import { render, staticRenderFns } from "./IconRadioButtons.vue?vue&type=template&id=5ee199f5&scoped=true&"
import script from "./IconRadioButtons.vue?vue&type=script&lang=js&"
export * from "./IconRadioButtons.vue?vue&type=script&lang=js&"
import style0 from "./IconRadioButtons.vue?vue&type=style&index=0&id=5ee199f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee199f5",
  null
  
)

export default component.exports